/**
 * Generate SHA-256 hash of text content
 * Used for content integrity verification in notarized records
 */
export async function sha256(text: string): Promise<string> {
  const data = new TextEncoder().encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = [...new Uint8Array(hashBuffer)];
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Verify content against its hash
 */
export async function verifyHash(content: string, expectedHash: string): Promise<boolean> {
  const actualHash = await sha256(content);
  return actualHash === expectedHash;
}